import type { components } from "../api/schema";

type MarkerResponse = components["schemas"]["MarkerResponse"];

export function markerReferenceWarningDescription(
  marker: MarkerResponse,
): string | undefined {
  const warnings = (marker.current_revision.references ?? []).flatMap(
    (reference) =>
      typeof reference.warning === "string"
        ? [`${reference.key}: ${reference.warning}`]
        : [],
  );
  return warnings.length === 0
    ? undefined
    : `Reference warnings: ${warnings.join("; ")}`;
}
